export interface GlutenFreeProps {
  isVegan: boolean
  isVegetarian: boolean
}

export const useGlutenFree = (props: GlutenFreeProps) => {
  return {
    ...props,
  }
}
